import { useEffect, useState, useRef, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import Sidebar from "../components/Sidebar";
import "../styles/dashboard.css";
import "../styles/beneficiaryProfile.css";
import { QRCodeCanvas } from "qrcode.react";
import QRCode from "qrcode";
import logoImg from "../assets/rhcwf-logo.jpeg";
import signature from "../assets/signature.png";

import html2pdf from "html2pdf.js";

export default function BeneficiaryProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [beneficiary, setBeneficiary] = useState(null);
  const [householdMembers, setHouseholdMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showMemberModal, setShowMemberModal] = useState(false);
  const [editingMember, setEditingMember] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentNote, setPaymentNote] = useState("");
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [showQrCode, setShowQrCode] = useState(false);
  const [generatedPayment, setGeneratedPayment] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [existingPayment, setExistingPayment] = useState(null);
  
  // States for UPI payment details
  const [showUpiDetailsModal, setShowUpiDetailsModal] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [upiId, setUpiId] = useState("");
  const [paymentScreenshot, setPaymentScreenshot] = useState(null);
  const [currentPaymentId, setCurrentPaymentId] = useState(null);
  
  const householdMembersRef = useRef(householdMembers);
  const beneficiaryRef = useRef(beneficiary);
  const userRole = localStorage.getItem("userRole");
const isAdmin =
  userRole === "ADMIN" || userRole === "Admin";
  const [memberForm, setMemberForm] = useState({ 
    name: "", 
    age: "", 
    relation: "", 
    gender: "",
    photo: null 
  });
  const [photoPreview, setPhotoPreview] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    householdMembersRef.current = householdMembers;
  }, [householdMembers]);

  useEffect(() => {
    beneficiaryRef.current = beneficiary;
  }, [beneficiary]);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const [beneficiaryRes, membersRes, paymentsRes] = await Promise.all([
        api.get(`/beneficiary/${id}`),
        api.get(`/beneficiary/${id}/household`),
        api.get(`/payments`).catch(() => ({ data: [] }))
      ]);
      
      console.log("Beneficiary data:", beneficiaryRes.data);
      console.log("Payments data:", paymentsRes.data);
      
      const beneficiaryData = beneficiaryRes.data;
      
      // IMPORTANT: Fix the payment matching logic
      // Try to match by beneficiaryId or userId
      const userPayments = paymentsRes.data.filter(p => {
        // Check if payment is for this beneficiary
        return p.beneficiaryId === beneficiaryData.beneficiaryId || 
               p.beneficiaryId === beneficiaryData.id ||
               p.userId === beneficiaryData.userId ||
               p.userId === beneficiaryData.id;
      });
      
      console.log("Matched payments for beneficiary:", userPayments);
      
      // const completedPayment = userPayments.find(p => p.status === "PAID");
      // const pendingPayment = userPayments.find(p => p.status === "PENDING");

      const completedPayment = userPayments.find(
  p => p.status?.toUpperCase() === "PAID"
);

const pendingPayment = userPayments.find(
  p => p.status?.toUpperCase() === "PENDING"
);
      
      if (completedPayment) {
        console.log("Found completed payment:", completedPayment);
        setPaymentStatus("PAID");
        setExistingPayment(completedPayment);
      } else if (pendingPayment) {
        console.log("Found pending payment:", pendingPayment);
        setPaymentStatus("PENDING");
        setExistingPayment(pendingPayment);
      } else {
        console.log("No payment found");
        setPaymentStatus(null);
        setExistingPayment(null);
      }
      
      setBeneficiary(beneficiaryData);
      setHouseholdMembers(membersRes.data);
    } catch (err) {
      console.error("Failed to load profile", err);
      alert("Could not load beneficiary data");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const dataURLtoBlob = (dataURL) => {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

 const openMemberModal = (member = null) => {
  if (beneficiary?.cardType === "INDIVIDUAL") {
    alert("Individual card holders cannot add household members. Only Family card holders can add members.");
    return;
  }
  
  // ✅ ADD THIS CHECK - Prevent adding when already 3 members
  if (!member && householdMembers.length >= 3) {
    alert("Maximum 3 household members already added for this Family Card.");
    return;
  }
  
  if (member) {
    setEditingMember(member);
    setMemberForm({ 
      name: member.name, 
      age: member.age, 
      relation: member.relation, 
      gender: member.gender,
      photo: null 
    });
    setPhotoPreview(member.photo ? `data:image/jpeg;base64,${member.photo}` : null);
  } else {
    setEditingMember(null);
    setMemberForm({ name: "", age: "", relation: "", gender: "", photo: null });
    setPhotoPreview(null);
  }
  setShowMemberModal(true);
};
  const handleMemberChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      const file = files[0];
      setMemberForm({ ...memberForm, photo: file });
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => setPhotoPreview(reader.result);
        reader.readAsDataURL(file);
      } else {
        setPhotoPreview(null);
      }
    } else {
      setMemberForm({ ...memberForm, [name]: value });
    }
  };

  const saveMember = async () => {
    if (beneficiary?.cardType === "INDIVIDUAL") {
      alert("Individual card holders cannot add household members.");
      return;
    }
    
    if (!memberForm.name || !memberForm.age || !memberForm.relation || !memberForm.gender) {
      alert("All fields are required");
      return;
    }
    
    setSubmitLoading(true);
    try {
      const formData = new FormData();
      formData.append("name", memberForm.name);
      formData.append("age", memberForm.age);
      formData.append("relation", memberForm.relation);
      formData.append("gender", memberForm.gender);
      if (memberForm.photo) {
        formData.append("photo", memberForm.photo);
      }
      
      if (editingMember) {
        await api.put(`/beneficiary/household/${editingMember.id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        alert("Member updated successfully!");
      } else {
        await api.post(`/beneficiary/${id}/household`, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        alert("Member added successfully!");
      }
      setShowMemberModal(false);
      loadData();
    } catch (err) {
      console.error("Failed to save member", err);
      alert(err.response?.data || "Failed to save member");
    } finally {
      setSubmitLoading(false);
    }
  };

  const deleteMember = async (memberId) => {
    if (window.confirm("Delete this household member?")) {
      try {
        await api.delete(`/beneficiary/household/${memberId}`);
        alert("Member deleted successfully");
        loadData();
      } catch (err) {
        alert("Delete failed");
      }
    }
  };
  const handleRazorpayPayment = async () => {
  setPaymentLoading(true);

  try {
    const loaded = await loadRazorpayScript();

    if (!loaded) {
      alert("Razorpay SDK failed to load");
      return;
    }

    const amount = beneficiary?.cardType === "FAMILY" ? 2: 1;

    const orderRes = await api.post("/payments/registration/init", {
      userId: beneficiary.userId || beneficiary.id,
      beneficiaryId: beneficiary.beneficiaryId,
      amount: amount,
      description: `Payment for ${beneficiary.cardType === "FAMILY" ? "Family" : "Individual"} card`,
      paymentMethod: "RAZORPAY"
    });

    const paymentId = orderRes.data.paymentId;

    const options = {
      key: "rzp_live_T2zVuDM09kAR4w",
      amount: orderRes.data.amount,
      currency: orderRes.data.currency,
      name: "RHCWF",
      description: `Beneficiary Card Payment - ${beneficiary.headName}`,
      order_id: orderRes.data.orderId,

      handler: async function (response) {
        try {
          const verifyRes = await api.post("/payments/razorpay-verify", {
            paymentId: paymentId,
            razorpayOrderId: response.razorpay_order_id,
            razorpayPaymentId: response.razorpay_payment_id,
            razorpaySignature: response.razorpay_signature
          });

          setPaymentStatus("PAID");
          setExistingPayment(verifyRes.data);
          setShowPaymentModal(false);

          alert("✅ Razorpay payment successful. Print button enabled.");

          await loadData();
        } catch (err) {
          console.error("Payment verification failed:", err);
          alert("Payment done but verification failed");
        }
      },

      prefill: {
        name: beneficiary.headName,
        contact: beneficiary.mobile
      },

      theme: {
        color: "#1a472a"
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();

  } catch (err) {
    console.error("Razorpay payment error:", err);
    alert(err.response?.data?.message || "Unable to start Razorpay payment");
  } finally {
    setPaymentLoading(false);
  }
};
const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};
  const handleMakePayment = () => {
    if (paymentStatus === "PAID") {
      alert(`✅ Payment already completed!\n\nPayment ID: ${existingPayment?.id}\nAmount: ₹${existingPayment?.amount}\nTransaction ID: ${existingPayment?.transactionId || 'N/A'}\nDate: ${new Date(existingPayment?.paidAt || existingPayment?.createdAt).toLocaleDateString()}`);
      return;
    }
    
    if (paymentStatus === "PENDING") {
      alert(`⏳ Payment is pending!\n\nPayment ID: ${existingPayment?.id}\nAmount: ₹${existingPayment?.amount}\nPlease complete the payment and submit transaction details.`);
      setCurrentPaymentId(existingPayment?.id);
      setShowUpiDetailsModal(true);
      return;
    }
    
    setPaymentMethod("");
    setPaymentNote("");
    setShowQrCode(false);
    setGeneratedPayment(null);
    
    const amount = beneficiary?.cardType === "FAMILY" ? 2 : 1;
    setPaymentAmount(amount);
    setShowPaymentModal(true);
  };

 const handleGenerateQRPayment = async () => {
  if (!paymentMethod) {
    alert("Please select a payment method");
    return;
  }

  if (paymentMethod !== "UPI") {
    alert("QR payment is only available for UPI method");
    return;
  }

  setPaymentLoading(true);
  try {
    // ✅ FIX: Get current logged-in coordinator from localStorage
    const currentUserId = localStorage.getItem("userId");
    const currentUserName = localStorage.getItem("userName");
    
    console.log("Current Coordinator ID:", currentUserId);
    console.log("Current Coordinator Name:", currentUserName);
    
    const paymentRequest = {
      userId: beneficiary.userId || beneficiary.id,
      beneficiaryId: beneficiary.beneficiaryId,
      amount: paymentAmount,
      description: paymentNote || `Payment for ${beneficiary.cardType === "FAMILY" ? "Family" : "Individual"} card`,
      paymentMethod: "ONLINE_QR",
      status: "PENDING",
      createdBy: currentUserId ? parseInt(currentUserId) : null,  // ✅ Use localStorage value
      createdByName: currentUserName || ""  // ✅ Use localStorage value
    };

    console.log("Sending payment request:", paymentRequest);

    const response = await api.post("/payments", paymentRequest);
    
    if (response.data) {
      setGeneratedPayment({
        id: response.data.id,
        userName: beneficiary.headName,
        amount: paymentAmount,
        beneficiaryId: beneficiary.beneficiaryId,
        cardType: beneficiary.cardType,
        description: paymentNote,
        paymentId: response.data.id
      });
      setCurrentPaymentId(response.data.id);
      setShowQrCode(true);
      setShowPaymentModal(false);
      setPaymentStatus("PENDING");
      setExistingPayment(response.data);
    } else {
      alert("Failed to generate payment QR code");
    }
  } catch (err) {
    console.error("Payment generation error:", err);
    alert(err.response?.data?.message || "Failed to generate payment. Please try again.");
  } finally {
    setPaymentLoading(false);
  }
};

  const handleOfflinePayment = async () => {
  if (!paymentMethod) {
    alert("Please select a payment method");
    return;
  }

  if (paymentMethod === "UPI") {
    alert("For UPI payments, please use 'Generate QR Code' button");
    return;
  }

  setPaymentLoading(true);
  try {
    // ✅ FIX: Get current logged-in coordinator from localStorage
    const currentUserId = localStorage.getItem("userId");
    const currentUserName = localStorage.getItem("userName");
    
    const paymentRequest = {
      userId: beneficiary.userId || beneficiary.id,
      beneficiaryId: beneficiary.beneficiaryId,
      amount: paymentAmount,
      description: paymentNote || `Offline payment for ${beneficiary.cardType === "FAMILY" ? "Family" : "Individual"} card`,
      paymentMethod: paymentMethod,
      status: "PAID",
      createdBy: currentUserId ? parseInt(currentUserId) : null,  // ✅ Use localStorage value
      createdByName: currentUserName || ""  // ✅ Use localStorage value
    };

    console.log("Sending offline payment request:", paymentRequest);

    const response = await api.post("/payments", paymentRequest);
    
    if (response.data) {
      alert(`✅ Payment of ₹${paymentAmount} recorded successfully for ${beneficiary.cardType === "FAMILY" ? "Family" : "Individual"} card!`);
      setShowPaymentModal(false);
      setPaymentMethod("");
      setPaymentNote("");
      setPaymentStatus("PAID");
      setExistingPayment(response.data);
      // await loadData();
      setPaymentStatus("PAID");

// Optional: delay reload
setTimeout(() => {
  loadData();
}, 1500);
    } else {
      alert("Payment failed: " + (response.data.message || "Unknown error"));
    }
  } catch (err) {
    console.error("Payment error:", err);
    alert(err.response?.data?.message || "Payment failed. Please try again.");
  } finally {
    setPaymentLoading(false);
  }
};

  const handleSubmitUpiDetails = async () => {
    if (!transactionId) {
      alert("Please enter Transaction ID / UTR number");
      return;
    }
    
    if (!upiId) {
      alert("Please enter the UPI ID used for payment");
      return;
    }
    
    if (!paymentScreenshot) {
      alert("Please upload a payment screenshot");
      return;
    }
    
    setPaymentLoading(true);
    try {
      const formData = new FormData();
      formData.append("transactionId", transactionId);
      formData.append("upiId", upiId);
      
      if (paymentScreenshot) {
        const blob = dataURLtoBlob(paymentScreenshot);
        formData.append("paymentScreenshot", blob, "screenshot.jpg");
      }
      
      const response = await api.put(`/payments/${currentPaymentId}/complete`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      
      console.log("Payment completed response:", response.data);
      
      alert("✅ Payment completed successfully! Transaction ID: " + transactionId);
      
      // Reset all form states
      setShowUpiDetailsModal(false);
      setTransactionId("");
      setUpiId("");
      setPaymentScreenshot(null);
      setCurrentPaymentId(null);
      
      // Update local state immediately
      setPaymentStatus("PAID");
      if (response.data) {
        setExistingPayment(response.data);
      } else if (existingPayment) {
        setExistingPayment({
          ...existingPayment,
          status: "PAID",
          transactionId: transactionId,
          upiId: upiId,
          paidAt: new Date().toISOString()
        });
      }
      
      // Reload data to ensure consistency
      await loadData();
      
    } catch (err) {
      console.error("Error submitting payment details:", err);
      const errorMessage = err.response?.data?.message || err.response?.data || err.message;
      alert("Failed to complete payment: " + errorMessage);
    } finally {
      setPaymentLoading(false);
    }
  };

  const handleScreenshotUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPaymentScreenshot(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEditDetails = () => {
    navigate(`/beneficiary/edit/${id}`);
  };
  const getBase64FromImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      resolve(canvas.toDataURL("image/png"));
    };

    img.onerror = reject;
    img.src = src;
  });
};
const handlePrintIdCard = async () => {
if (paymentStatus == "PAID") {
  alert("❌ Please complete payment before printing ID card");
  return;
}
  const confirmPrint = window.confirm(
    "⚠️ IMPORTANT: Please verify the following before printing:\n\n" +
    "📋 CHECKLIST:\n" +
    "✓ Beneficiary details are correct\n" +
    "✓ Photo is visible\n" +
    "✓ Payment status is updated\n" +
    "✓ Household members are added (if Family Card)\n\n" +
    "Click OK to generate and print the ID card.\n" +
    "Click Cancel to go back and make changes."
  );
  
  if (!confirmPrint) {
    return;
  }
  
  const loader = document.createElement('div');
  loader.id = 'id-card-loader';
  loader.textContent = 'Generating ID Card... Please wait.';
  loader.style.cssText = `
    position:fixed;top:50%;left:50%;
    transform:translate(-50%,-50%);
    background:rgba(0,0,0,0.82);color:#fff;
    padding:18px 30px;border-radius:10px;
    z-index:9999;font-family:sans-serif;font-size:14px;
  `;
  document.body.appendChild(loader);
  const hideLoader = () => {
    const el = document.getElementById('id-card-loader');
    if (el) el.remove();
  };

  try {
    const ben = beneficiaryRef.current;
    const members = householdMembersRef.current || [];

    if (!ben) { 
      alert("No beneficiary data to print"); 
      hideLoader(); 
      return; 
    }

    if (!ben.photo) {
      const proceedWithoutPhoto = window.confirm(
        "⚠️ Warning: No photo found for the beneficiary.\n\n" +
        "The ID card will be generated without a photo.\n" +
        "Do you want to continue?"
      );
      if (!proceedWithoutPhoto) {
        hideLoader();
        return;
      }
    }

  const issueDate = ben.cardIssueDate
    ? new Date(ben.cardIssueDate)
    : new Date();

const expiryDate = ben.cardValidTill
    ? new Date(ben.cardValidTill)
    : new Date();

    const fmt = (d) =>
      `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;

    const fmtLong = (d) =>
      d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });

    const mainPhoto = ben.photo
      ? `
        <div style="
          width: 120px;
          height: 120px;
          border-radius: 50%;
          border: 4px solid #c9a84c;
          padding: 3px;
          background: white;
          box-shadow: 0 4px 10px rgba(0,0,0,0.15);
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        ">
          <img src="data:image/jpeg;base64,${ben.photo}"
               style="width:100%;height:100%;object-fit:cover;border-radius:50%;" />
        </div>
      `
      : `
        <div style="
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: #f0f4f0;
          display:flex;
          align-items: center;
          justify-content:center;
          font-size:40px;
          border: 3px solid #d1d5db;
        ">
          📷
        </div>
      `;

    const payText = paymentStatus === "PAID" ? "PAID"
      : paymentStatus === "PENDING" ? "PENDING" : "NOT PAID";
    const payBg = paymentStatus === "PAID" ? "#d1fae5"
      : paymentStatus === "PENDING" ? "#fef3c7" : "#f3f4f6";
    const payColor = paymentStatus === "PAID" ? "#065f46"
      : paymentStatus === "PENDING" ? "#92400e" : "#6b7280";

    const memberRows = members.length
      ? members.map((m, i) => {
          const g = m.gender === 'MALE' ? 'M' : m.gender === 'FEMALE' ? 'F' : 'O';
          const photo = m.photo
            ? `<img src="data:image/jpeg;base64,${m.photo}"
                   style="width:32px;height:32px;border-radius:50%;object-fit:cover;" />`
            : `<div style="width:32px;height:32px;border-radius:50%;
                   background:#1a472a;color:#fff;font-size:13px;font-weight:700;
                   display:inline-flex;align-items:center;justify-content:center;">
                 ${(m.name || 'M')[0].toUpperCase()}
               </div>`;
          const bg = i % 2 === 0 ? '#ffffff' : '#f9fafb';
          return `
            <tr style="background:${bg}">
              <td style="padding:8px 10px;font-size:11px;text-align:center;">${i + 1}</td>
              <td style="padding:8px 10px;text-align:center;">${photo}</td>
              <td style="padding:8px 10px;font-size:11px;">${(m.name || 'N/A')}</td>
              <td style="padding:8px 10px;font-size:11px;text-align:center;">${m.age || 'N/A'}</td>
              <td style="padding:8px 10px;font-size:11px;">${m.relation || 'Member'}</td>
              <td style="padding:8px 10px;font-size:11px;text-align:center;">${g}</td>
            </tr>`;
        }).join('')
      : `<tr><td colspan="6" style="padding:20px;text-align:center;
             color:#9ca3af;font-size:11px;">No household members added</td></tr>`;

    const verifyUrl = `${window.location.origin}/verify-card/${ben.beneficiaryId}`;
    const qrDataUrl = await QRCode.toDataURL(verifyUrl, {
      width: 180,
      margin: 1
    });

    const logoSvg = `
      <svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22" cy="22" r="21" fill="white" stroke="#c9a84c" stroke-width="1.5"/>
        <circle cx="22" cy="22" r="17" fill="#1a472a"/>
        <rect x="19" y="12" width="6" height="20" rx="1.5" fill="white"/>
        <rect x="12" y="19" width="20" height="6" rx="1.5" fill="white"/>
        <path d="M10 28 Q15 35 22 36 Q29 35 34 28" stroke="white" stroke-width="1.5" fill="none" opacity="0.5"/>
      </svg>`;

      const logoDataUrl = await getBase64FromImage(logoImg);
    const element = document.createElement('div');
    element.style.cssText = `
      display: block;
      width: 100%;
      background: white;
    `;
    const signatureDataUrl = await getBase64FromImage(signature);
const loggedInUser = localStorage.getItem("userName") || "N/A";
const loggedInRole = localStorage.getItem("userRole") || "";
    element.innerHTML = `
      <div class="card" style="width: 100%; max-width: 794px; background: white; border-radius: 16px; overflow: hidden; box-shadow: 0 8px 24px rgba(0,0,0,0.18); font-family: 'Segoe UI', Arial, sans-serif;">
        
        <!-- Header -->
     <div class="f-hdr" style="
  background: #1a472a;
  padding: 14px 20px 14px 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  justify-content: space-between;
">

  <!-- LEFT SIDE -->
  <div style="display:flex; align-items:center; gap:14px;">
    <div style="width: 56px; height: 56px; border-radius: 50%; background: white; border: 2.5px solid #c9a84c; display: flex; align-items: center; justify-content: center;">
     <img
    src="${logoDataUrl}"
    style="
        width:50px;
        height:50px;
        border-radius:50%;
        object-fit:cover;
    "
/>
    </div>

    <div>
      <div style="color: white; font-size: 12px; font-weight: 800; line-height: 1.35; text-transform: uppercase;">
        RE-CONNECTING  HEALTH CARE AND<br>WELFARE FOUNDATION (NGO)
      </div>
      
      
    </div>
  </div>

  <!-- RIGHT SIDE -->
  <div style="display:flex; flex-direction:column; align-items:flex-end; gap:6px;">
    
    <!-- CARD NUMBER -->
    <div style="text-align:right;">
      <div style="font-size:9px; color:#d1fae5; font-weight:600;">Benificiary Card</div>
     
    </div>

    <!-- ACTIVE BADGE -->
    <div style="
      background: #16a34a;
      color: white;
      padding: 4px 10px;
      border-radius: 20px;
      font-size: 9px;
      font-weight: 700;
    ">
      ✓ ACTIVE
    </div>

  </div>

</div>
        
        <div style="height: 6px; background: linear-gradient(90deg, #b8860b 0%, #c9a84c 30%, #ffd700 50%, #c9a84c 70%, #b8860b 100%);"></div>
        
        <!-- Main Content Area -->
        <div style="padding: 20px 22px 0 22px; display: flex; gap: 20px; align-items: flex-start;">
          
          <!-- Left: Photo -->
          <div style="width: 115px; height: 145px; border: 2px solid #d1d5db; border-radius: 8px; overflow: hidden; background: #f9fafb; display: flex; align-items: center; justify-content: center;">
            ${mainPhoto}
          </div>
          
          <!-- Middle: Details -->
          <div style="flex: 1; padding-top: 4px;">
            
           
            <div style="margin-bottom: 12px;">
              <div style="font-size: 9px; font-weight: 700; color: #9ca3af; text-transform: uppercase; letter-spacing: 0.5px;">Card No.</div>
              <div style="font-family: 'Courier New', monospace; font-size: 13px; font-weight: 700; color: #1a472a; margin-top: 2px;">${ben.beneficiaryId || 'RCRHCWF-0000-0000'}</div>
            </div>
            <div style="margin-bottom: 12px;">
              <div style="font-size: 9px; font-weight: 700; color: #9ca3af; text-transform: uppercase; letter-spacing: 0.5px;">Name of Head / Beneficiary</div>
              <div style="font-size: 12px; font-weight: 600; color: #111827; margin-top: 2px;">${(ben.headName || 'N/A').toUpperCase()}</div>
            </div>
              <!-- Age -->
            <div style="margin-bottom: 12px;">
              <div style="font-size: 9px; font-weight: 700; color: #9ca3af; text-transform: uppercase; letter-spacing: 0.5px;">Age</div>
              <div style="font-size: 12px; font-weight: 800; color: #111827; margin-top: 2px;">${ben.age || 'N/A'} Yrs</div>
            </div>
            <div style="margin-bottom: 10px;">
              <div style="font-size: 9px; font-weight: 700; color: #9ca3af; text-transform: uppercase; letter-spacing: 0.5px;">Gender</div>
              <div style="font-size: 12px; font-weight: 600; color: #111827; margin-top: 2px;">${ben.gender || 'N/A'}</div>
            </div>
            <div style="margin-bottom: 10px;">
              <div style="font-size: 9px; font-weight: 700; color: #9ca3af; text-transform: uppercase; letter-spacing: 0.5px;">Mobile</div>
              <div style="font-size: 12px; font-weight: 600; color: #111827; margin-top: 2px;">${ben.mobile || 'N/A'}</div>
            </div>
            
          </div>
          
          <!-- Right: QR → Age → Valid Till (simplified, no Card Type, no Payment) -->
          <div style="display: flex; flex-direction: column; align-items: center; width: 150px; padding-top: 0px; gap: 16px;">
            
            <!-- QR Code (Top) -->
            <div style="display: flex; flex-direction: column; align-items: center;">
              <img src="${qrDataUrl}" style="width: 90px; height: 90px; object-fit: contain;" />
              <div style="font-size: 9px; color: #444; font-weight: 600; text-align: center; margin-top: 5px;">
                Scan to verify
              </div>
            </div>
              <div style="
    display:flex;
    flex-direction:column;
    align-items:center;
    width:100%;
    margin-top:8px;
">

    <img
        src="${signatureDataUrl}"
        style="
            height:32px;
            width:auto;
            object-fit:contain;
            margin-bottom:4px;
        "
    />

    <div style="
        width:120px;
        border-bottom:1.5px solid #374151;
        margin-bottom:4px;
    "></div>

    <div style="
        font-size:9px;
        font-weight:700;
        color:#374151;
        text-transform:uppercase;
        letter-spacing:0.5px;
    ">
        AUTHORISED SIGNATURE
    </div>

</div>
</div>
        </div>
          
            
            
          </div>
        </div>
        
        <!-- AUTHORISED SIGNATURE SECTION - Moved to bottom, centered -->
     
        
        <!-- Footer -->
        <div style="background: #1a472a; padding: 8px 22px; display: flex; justify-content: space-between; font-size: 9px; color: #d1fae5; font-weight: 500;">
          <span>Issued: ${fmtLong(issueDate)}</span>
          <span>Expiry: ${fmtLong(expiryDate)}</span>
        </div>
      </div>

      <!-- Household Members Section -->
      <div class="card" style="width: 100%; max-width: 794px; background: white; border-radius: 16px; overflow: hidden; box-shadow: 0 8px 24px rgba(0,0,0,0.18); margin-top: 22px;">
       
        <div style="height: 4px; background: linear-gradient(90deg, #b8860b 0%, #c9a84c 30%, #ffd700 50%, #c9a84c 70%, #b8860b 100%);"></div>
        <div style="padding: 18px 20px;">
          <div style="font-size: 11px; font-weight: 800; color: #1a472a; text-transform: uppercase; margin-bottom: 12px;">Household Members</div>
          <table style="width: 100%; border-collapse: collapse; border-radius: 8px; overflow: hidden; border: 1px solid #e5e7eb;">
            <thead>
              <tr style="background: #1a472a;">
                <th style="padding: 8px 10px; font-size: 10px; font-weight: 700; color: white; text-align: center; width: 6%;">SL.</th>
                <th style="padding: 8px 10px; font-size: 10px; font-weight: 700; color: white; text-align: center; width: 10%;">Photo</th>
                <th style="padding: 8px 10px; font-size: 10px; font-weight: 700; color: white; text-align: left; width: 36%;">Full Name</th>
                <th style="padding: 8px 10px; font-size: 10px; font-weight: 700; color: white; text-align: center; width: 10%;">Age</th>
                <th style="padding: 8px 10px; font-size: 10px; font-weight: 700; color: white; text-align: left; width: 23%;">Relation</th>
                <th style="padding: 8px 10px; font-size: 10px; font-weight: 700; color: white; text-align: center; width: 15%;">Gender</th>
              </tr>
            </thead>
            <tbody>${memberRows}</tbody>
          </table>
          
<div style="
    display:flex;
    align-items:flex-start;
    gap:18px;
    background:#f9fafb;
    border:1px solid #e5e7eb;
    border-radius:8px;
    padding:12px 16px;
    margin:14px 0;
">

    <div style="width:20%;">
        <strong style="color:#1a472a;">👤 Coordinator</strong><br>
        ${loggedInUser}
    </div>

    <div style="width:20%;">
        <strong style="color:#1a472a;">🏡 Village</strong><br>
        ${ben.village || 'N/A'}
    </div>

    <div style="width:45%;">
        <strong style="color:#1a472a;">📍 Address</strong><br>
        ${ben.fullAddress || 'N/A'}
    </div>

    <div style="width:15%;">
        <strong style="color:#1a472a;">📮 PIN</strong><br>
        ${ben.pinCode || 'N/A'}
    </div>

</div>          
          <!-- Customer Support at bottom of household section -->
         <!-- Office Headquarters & Customer Support -->
<div style="
    display:flex;
    justify-content:space-between;
    align-items:flex-start;
    margin-top:16px;
    padding-top:14px;
    border-top:1px solid #e5e7eb;
">

    <!-- Left Side -->
    <div style="font-size:9px; color:#374151; line-height:1.6;">
        <div style="font-weight:700; color:#1a472a; margin-bottom:5px;">
            🏢 Office Headquarters
        </div>

        <div>
            Reconnecting Health Care AND Welfare Foundation (NGO)<br>
            Head Office Bamuntari Barpeta,
            Assam - 781319
        </div>
    </div>

    <!-- Right Side -->
    <div style="font-size:9px; color:#374151; line-height:1.6; text-align:right;">
        <div style="font-weight:700; color:#1a472a; margin-bottom:5px;">
            📞 Contacts Details
        </div>

        <div>
            +91 7002639369 / 7002694744<br>
            +91 9101699554 / 8753976812
        </div>

       
    </div>

</div>
        </div>
        <div style="
  height: 6px;
  background: linear-gradient(90deg, #b8860b 0%, #c9a84c 30%, #ffd700 50%, #c9a84c 70%, #b8860b 100%);
"></div>
      </div>
    `;

    const opt = {
      margin: [0.5, 0.5, 0.5, 0.5],
      filename: `ID_Card_${ben.beneficiaryId || ben.headName}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { 
        scale: 2, 
        useCORS: true,
        logging: false,
        letterRendering: true,
        backgroundColor: '#ffffff'
      },
      jsPDF: { 
        unit: 'in', 
         format: [54, 86],   // 54mm × 86mm (ID card size)
        orientation: 'portrait',
        compress: true
      },
      pagebreak: { mode: 'avoid-all' }
    };

    html2pdf().set(opt).from(element).save().then(async () => {
      try {
        await api.put(`/beneficiary/${ben.id}/card-issued`);
        hideLoader();
        alert(
          "✅ ID Card PDF generated successfully!\n\n" +
          "Card has been marked as ISSUED in database."
        );
        await loadData();
      } catch (err) {
        console.error("Card issue update failed:", err);
        hideLoader();
        alert(
          "⚠️ PDF generated successfully,\n" +
          "but card issued status was not updated in database."
        );
      }
    });

  } catch (err) {
    console.error("Print error:", err);
    alert("❌ Error printing ID card. Please try again.");
    hideLoader();
  }
};
  if (loading) {
    return (
      <div className="dashboard-container">
        <Sidebar />
        <div className="dashboard-content">
          <div className="loading-spinner">Loading...</div>
        </div>
      </div>
    );
  }
  
  if (!beneficiary) {
    return (
      <div className="dashboard-container">
        <Sidebar />
        <div className="dashboard-content">
          <div className="error-message">Beneficiary not found</div>
        </div>
      </div>
    );
  }

  const isFamilyCard = beneficiary.cardType === "FAMILY";
  const paymentAmountDisplay = isFamilyCard ? 2 : 1;
const isPaymentCompleted = paymentStatus?.toUpperCase() === "PAID";
  const isPaymentPending = paymentStatus === "PENDING";

  return (
<div className="dashboard-container">
    <Sidebar />
    <div className="dashboard-content">
      <div className="dashboard-header">
        <div className="header-title">
          <h1>Coordinator Panel</h1>
          <p>Beneficiary Profile – Complete household information</p>
        </div>
        <div className="header-date">{new Date().toLocaleDateString()}</div>
      </div>

      <div className="profile-grid">
        
        {/* Profile Card - ONLY ONE */}
        <div className="profile-card">
          <h2>Beneficiary Profile</h2>
          
          {/* Photo Section */}
          <div className="profile-photo">
            {beneficiary.photo ? (
              <img 
                src={`data:image/jpeg;base64,${beneficiary.photo}`}
                alt={beneficiary.headName}
              />
            ) : (
              <div>📷</div>
            )}
          </div>
          
          {/* Info Section - WRAPPED IN profile-info */}
          <div className="profile-info">
            <div className="profile-row">
              <span className="label">📋 Beneficiary ID:</span>
              <span>{beneficiary.beneficiaryId}</span>
            </div>
            <div className="profile-row">
              <span className="label">👤 Head Name:</span>
              <span>{beneficiary.headName}</span>
            </div>
            <div className="profile-row">
              <span className="label">⚥ Gender:</span>
              <span>{beneficiary.gender}</span>
            </div>
            <div className="profile-row">
              <span className="label">🎂 Age:</span>
              <span>{beneficiary.age} yrs</span>
            </div>
            <div className="profile-row">
              <span className="label">📞 Contact:</span>
              <span>{beneficiary.mobile}</span>
            </div>
            <div className="profile-row">
              <span className="label">💳 Payment Status:</span>
              <span className={
                isPaymentCompleted ? "status-paid" : 
                isPaymentPending ? "status-pending" : 
                "status-not-started"
              }>
                {isPaymentCompleted ? "PAID" : isPaymentPending ? "PENDING" : "NOT STARTED"}
              </span>
            </div>
            <div className="profile-row">
              <span className="label">💰 Payment Amount:</span>
              <span>₹{paymentAmountDisplay}/year</span>
            </div>
            <div className="profile-row">
              <span className="label">📍 Address:</span>
              <span>{beneficiary.fullAddress}, PIN: {beneficiary.pinCode}</span>
            </div>
            <div className="profile-row">
              <span className="label">💳 Card Type:</span>
              <span style={{ fontWeight: "bold", color: isFamilyCard ? "#10b981" : "#f59e0b" }}>
                {isFamilyCard ? "👨‍👩‍👧‍👦 Family Card" : "👤 Individual Card"}
              </span>
            </div>
          </div>
        </div>

        {/* Actions Card - ONLY ONE, remove the duplicate */}
        <div className="profile-card actions-card">
          <h3>Quick Actions</h3>
          <div className="action-buttons">
            {/* <button
              className={isPaymentCompleted ? "btn-disabled" : "btn-primary"}
              onClick={handleRazorpayPayment}
              disabled={isPaymentCompleted || paymentLoading}
            >
              {paymentLoading ? "⏳ Processing..." : isPaymentCompleted ? "✅ Payment Completed" : `💳 Pay ₹${paymentAmountDisplay}`}
            </button> */}

           <button
  className="btn-secondary"
  onClick={handlePrintIdCard}
>
  🖨️ Print ID Card
</button>
            
            {isFamilyCard ? (
              <button className="btn-secondary" onClick={() => openMemberModal()} disabled={isPaymentCompleted}>
                👨‍👩‍👧 Add Member
              </button>
            ) : (
              <button className="btn-secondary" disabled style={{ opacity: 0.5, cursor: "not-allowed" }}>
                🚫 Cannot Add Members
              </button>
            )}
          </div>
          
          {isPaymentCompleted && (
            <div className="info-box" style={{ margin: "0 var(--spacing-xl) var(--spacing-xl)" }}>
              <p style={{ color: "var(--success-dark)", fontWeight: "bold", textAlign: "center" }}>
                ✅ Payment has been completed for this beneficiary
              </p>
            </div>
          )}
        </div>
        
      </div>

      {/* Household Members Section */}
      {isFamilyCard ? (
        <div className="revenue-card">
          <div className="section-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h2>👨‍👩‍👧‍👦 Household Members ({householdMembers.length} / 3)</h2>
            {householdMembers.length < 3 && !isPaymentCompleted && (
              <button className="export-excel-btn" onClick={() => openMemberModal()}>➕ Add Member</button>
            )}
          </div>
          {householdMembers.length === 0 ? (
            <div className="no-data">No members added yet. Click "Add Member" to add family members.</div>
          ) : (
            <>
    <table className="data-table">
<thead>
  <tr>
    <th>#</th>
    <th>Photo</th>
    <th>Name</th>
    <th>Age</th>
    <th>Relation</th>
    <th>Gender</th>

    {isAdmin && <th>Action</th>}
  </tr>
</thead>

  <tbody>
    {householdMembers.map((m, idx) => (
      <tr key={m.id}>
        <td data-label="#">{idx + 1}</td>

        <td data-label="Photo" className="photo-cell">
          {m.photo ? (
            <img
              src={`data:image/jpeg;base64,${m.photo}`}
              alt={m.name}
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "20px",
                objectFit: "cover"
              }}
            />
          ) : (
            <span style={{ fontSize: "24px" }}>👤</span>
          )}
        </td>

        <td data-label="Name">{m.name}</td>
        <td data-label="Age">{m.age}</td>
        <td data-label="Relation">{m.relation}</td>
        <td data-label="Gender">{m.gender}</td>

   
         {isAdmin && (
        <td data-label="Action">
          <button
            onClick={() => openMemberModal(m)}
            style={{ marginRight: "5px" }}
          >
            Edit
          </button>

          <button
            onClick={() => deleteMember(m.id)}
          >
            Delete
          </button>
        </td>
      )}
    </tr>
  ))}
</tbody>

</table>
              {householdMembers.length >= 3 && (
                <p style={{ textAlign: "center", color: "#f59e0b", marginTop: "10px" }}>
                  ⚠️ Maximum 3 household members reached for Family Card
                </p>
              )}
            </>
          )}
        </div>
      ) : (
        <div className="revenue-card">
          <div className="section-header">
            <h2>👤 Individual Card</h2>
          </div>
          <div className="no-data" style={{ textAlign: "center", padding: "40px" }}>
            <span style={{ fontSize: "48px" }}>🚫</span>
            <p style={{ marginTop: "10px" }}>Individual card holders cannot add household members.</p>
            <p style={{ fontSize: "14px", color: "#666" }}>Only Family card holders can add up to 3 household members.</p>
          </div>
        </div>
      )}

        {/* Payment Modal */}
        {showPaymentModal && (
          <div className="modal-overlay" onClick={() => setShowPaymentModal(false)}>
            <div className="modal-container edit-modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Make Payment - ₹{paymentAmount}</h3>
                <button className="modal-close" onClick={() => setShowPaymentModal(false)}>×</button>
              </div>
              <div className="modal-body edit-modal-body">
                <form className="edit-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label>Beneficiary Name</label>
                      <input type="text" value={beneficiary.headName} disabled style={{ background: "#f3f4f6" }} />
                    </div>
                    <div className="form-group">
                      <label>Card Type</label>
                      <input type="text" value={isFamilyCard ? "Family Card" : "Individual Card"} disabled style={{ background: "#f3f4f6" }} />
                    </div>
                  </div>
                  
                  <div className="form-row">
                    <div className="form-group">
                      <label>Payment Method *</label>
                      <select 
                        value={paymentMethod} 
                        onChange={(e) => setPaymentMethod(e.target.value)} 
                        required
                      >
                        <option value="">Select Payment Method</option>
                        <option value="CASH">💵 Cash</option>
                        <option value="CHEQUE">📝 Cheque</option>
                        <option value="UPI">📱 UPI (QR Code)</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Note (Optional)</label>
                      <textarea 
                        rows="3" 
                        value={paymentNote} 
                        onChange={(e) => setPaymentNote(e.target.value)}
                        placeholder="Any additional notes about the payment..."
                      />
                    </div>
                  </div>

                  {paymentMethod === "UPI" && (
                    <div className="info-box" style={{ background: "#e0f2fe", padding: "12px", borderRadius: "8px", marginTop: "10px" }}>
                      <p style={{ margin: 0, fontSize: "14px" }}>
                        📱 <strong>UPI Payment:</strong> Click "Generate QR Code" to create a UPI QR code. After payment, you'll need to submit the Transaction ID and screenshot.
                      </p>
                    </div>
                  )}

                  {paymentMethod && paymentMethod !== "UPI" && (
                    <div className="info-box" style={{ background: "#fef3c7", padding: "12px", borderRadius: "8px", marginTop: "10px" }}>
                      <p style={{ margin: 0, fontSize: "14px" }}>
                        💰 <strong>Offline Payment:</strong> The payment will be recorded immediately as PAID.
                      </p>
                    </div>
                  )}
                </form>
              </div>
              <div className="modal-footer">
                <button className="btn-secondary" onClick={() => setShowPaymentModal(false)}>Cancel</button>
                {paymentMethod === "UPI" ? (
                 <button
  className="btn-primary"
  onClick={handleRazorpayPayment}
  disabled={paymentLoading}
>
  {paymentLoading ? "Processing..." : "Pay with Razorpay Test"}
</button>
                ) : paymentMethod && (
                  <button 
                    className="btn-save" 
                    onClick={handleOfflinePayment} 
                    disabled={paymentLoading}
                    style={{ background: "#10b981" }}
                  >
                    {paymentLoading ? "Processing..." : `✅ Record Payment of ₹${paymentAmount}`}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {/* QR Code Modal */}
        {showQrCode && generatedPayment && (
          <div className="modal-overlay" onClick={() => setShowQrCode(false)}>
            <div className="modal-container qr-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "500px" }}>
              <div className="modal-header">
                <h3>UPI Payment QR Code</h3>
                <button className="modal-close" onClick={() => setShowQrCode(false)}>×</button>
              </div>
              <div className="modal-body" style={{ textAlign: "center", padding: "20px" }}>
                <p><strong>Beneficiary:</strong> {generatedPayment.userName}</p>
                <p><strong>Beneficiary ID:</strong> {generatedPayment.beneficiaryId}</p>
                <p><strong>Amount:</strong> ₹{generatedPayment.amount}</p>
                <p><strong>Card Type:</strong> {generatedPayment.cardType === "FAMILY" ? "Family Card" : "Individual Card"}</p>
                {generatedPayment.description && <p><strong>Note:</strong> {generatedPayment.description}</p>}
                
                <div className="qr-code" style={{ margin: "20px 0", padding: "20px", background: "white", display: "inline-block", borderRadius: "10px" }}>
                  <QRCodeCanvas
                    value={`upi://pay?pa=7002694744@ybl&pn=RHCWF&am=${generatedPayment.amount}&cu=INR&txn=${generatedPayment.id}&tn=${encodeURIComponent(generatedPayment.description || `Payment for ${generatedPayment.cardType} card`)}`}
                    size={250}
                    level="H"
                    includeMargin={true}
                  />
                </div>
                
                <p className="qr-instruction" style={{ color: "#10b981", fontWeight: "bold", margin: "10px 0" }}>
                  📱 Scan with any UPI app (Google Pay, PhonePe, Paytm, etc.)
                </p>
                
                <div style={{ marginTop: "20px", padding: "10px", background: "#fef3c7", borderRadius: "8px" }}>
                  <p style={{ margin: 0, fontSize: "12px", color: "#92400e" }}>
                    ⚠️ After completing the payment, click "OK" to submit Transaction ID and screenshot
                  </p>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn-primary" onClick={() => {
                  setShowQrCode(false);
                  setShowUpiDetailsModal(true);
                }}>
                  OK - Submit Payment Details
                </button>
              </div>
            </div>
          </div>
        )}

        {/* UPI Details Modal */}
        {showUpiDetailsModal && (
          <div className="modal-overlay" onClick={() => setShowUpiDetailsModal(false)}>
            <div className="modal-container edit-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "500px" }}>
              <div className="modal-header">
                <h3>Submit UPI Payment Details</h3>
                <button className="modal-close" onClick={() => setShowUpiDetailsModal(false)}>×</button>
              </div>
              <div className="modal-body edit-modal-body">
                <form className="edit-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label>Transaction ID / UTR Number *</label>
                      <input 
                        type="text" 
                        autoComplete="off"
                        value={transactionId} 
                        onChange={(e) => setTransactionId(e.target.value)}
                        placeholder="Enter UPI Transaction ID or UTR"
                        required
                      />
                      <small style={{ color: "#666", fontSize: "11px" }}>Example: 123456789012 or UPIREF123456</small>
                    </div>
                  </div>
                  
                  <div className="form-row">
                    <div className="form-group">
                      <label>UPI ID (Payer's UPI ID) *</label>
                      <input 
                        type="text" 
                        value={upiId} 
                        autoComplete="off"
                        onChange={(e) => setUpiId(e.target.value)}
                        placeholder="Enter the UPI ID used for payment"
                        required
                      />
                      <small style={{ color: "#666", fontSize: "11px" }}>Example: username@okhdfcbank</small>
                    </div>
                  </div>
                  
                  <div className="form-row">
                    <div className="form-group">
                      <label>Payment Screenshot *</label>
                      <input 
                        type="file" 
                        autoComplete="off"
                        accept="image/*" 
                        onChange={handleScreenshotUpload}
                        required
                      />
                      {paymentScreenshot && (
                        <div style={{ marginTop: "10px" }}>
                          <img 
                            src={paymentScreenshot} 
                            alt="Screenshot preview" 
                            style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "8px", border: "1px solid #e5e7eb" }}
                          />
                        </div>
                      )}
                      <small style={{ color: "#666", fontSize: "11px" }}>Upload screenshot of payment confirmation</small>
                    </div>
                  </div>
                  
                  <div className="info-box" style={{ background: "#fef3c7", padding: "12px", borderRadius: "8px", marginTop: "10px" }}>
                    <p style={{ margin: 0, fontSize: "12px", color: "#92400e" }}>
                      ⚠️ Please ensure all details are correct. This information will be saved with the payment record.
                    </p>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button className="btn-secondary" onClick={() => setShowUpiDetailsModal(false)}>Cancel</button>
                <button 
                  className="btn-save" 
                  onClick={handleSubmitUpiDetails} 
                  disabled={paymentLoading || !transactionId || !upiId || !paymentScreenshot}
                  style={{ background: "#10b981" }}
                >
                  {paymentLoading ? "Submitting..." : "✅ Complete Payment"}
                </button>
              </div>
            </div>
          </div>
        )}

        {showMemberModal && isFamilyCard && (
          <div className="modal-overlay" onClick={() => setShowMemberModal(false)}>
            <div className="modal-container edit-modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>{editingMember ? "Edit Household Member" : "Add Household Member"}</h3>
                <button className="modal-close" onClick={() => setShowMemberModal(false)}>×</button>
              </div>
              <div className="modal-body edit-modal-body">
                <form className="edit-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label>Profile Photo</label>
                      <input type="file"  name="photo" accept="image/*" onChange={handleMemberChange}  />
                      {photoPreview && (
                        <img 
                          src={photoPreview} 
                          alt="Preview" 
                          style={{ marginTop: "8px", width: "80px", height: "80px", borderRadius: "40px", objectFit: "cover" }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Name *</label>
                      <input type="text" name="name" autoComplete="off" value={memberForm.name} onChange={handleMemberChange} required />
                    </div>
                    <div className="form-group">
                      <label>Age *</label>
                      <input type="number" name="age" min="0" max="120" autoComplete="off" value={memberForm.age} onChange={handleMemberChange} required />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Relation *</label>
                      <input type="text" name="relation" autoComplete="off" placeholder="e.g., Spouse, Son, Daughter" value={memberForm.relation} onChange={handleMemberChange} required />
                    </div>
                    <div className="form-group">
                      <label>Gender *</label>
                      <select name="gender" value={memberForm.gender} onChange={handleMemberChange} required>
                        <option value="">Select</option>
                        <option value="MALE">Male</option>
                        <option value="FEMALE">Female</option>
                        <option value="OTHER">Other</option>
                      </select>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button className="btn-secondary" onClick={() => setShowMemberModal(false)}>Cancel</button>
                <button className="btn-save" onClick={saveMember} disabled={submitLoading}>
                  {submitLoading ? "Saving..." : "Save Member"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}